
import React, { useEffect, useState } from 'react';
import { TextField, FormControl, InputLabel, Select, MenuItem, Grid, Paper, useMediaQuery, Button, FormHelperText } from '@mui/material';
import styled, { inputStyles } from '../../Utils/inputChanges';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { fetchSingleBrand, updateBrandEntry } from '../../Store/PHPSlice/Rack';
import { selectSingleBrand } from '../Selectors/Master/ItemSelectors';


const BrandEdit = () => {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const { Id } = useParams();
    const [formData, setFormData] = useState({
        brandId: parseInt(Id),
        brandNm: '',
        userId: userdata?.ID
    });
    const dispatch = useDispatch();
    const brandlist = useSelector(selectSingleBrand);
    useEffect(() => {
        dispatch(fetchSingleBrand(Id));
    }, [dispatch]);
    useEffect(() => {
        if (brandlist.data.length > 0) {
            const item = brandlist.data[0];
            setFormData({
                ...formData,
                brandNm: item.brandNm,
            });
        }
    }, [brandlist]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });
    };


    const [errors, setErrors] = useState({});
    const handleSubmit = (event) => {
        event.preventDefault();
        // console.log(formData);

        dispatch(updateBrandEntry(formData))
            .unwrap()
            .then((result) => {
                // Handle success
                console.log('POST request successful!', result);
                // toast.success("Rack Updated Successful");
                alert("Record Updated.");
                window.close();
                // You may want to update your component state or perform any other action
            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });

    };



    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement


    return (
        <>
            <div style={{ margin: '1%' }}>
                <h2>Brand Edit</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '3vh', margin: '0' }}>
                            <Grid container spacing={2}>

                                <Grid item xs={12} md={6} >
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '35%' } : { width: '100%' }}>
                                            <InputLabel htmlFor='brandNm' >Brand Name:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                <TextField
                                                    id='brandNm'
                                                    name='brandNm'
                                                    value={formData.brandNm}
                                                    onChange={handleInputChange}
                                                    inputProps={{ style: styled.input }}
                                                    sx={inputStyles}

                                                />
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit}>Submit</Button>
                                </Grid>
                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>

            </div>
        </>
    );
}

export default BrandEdit;
